module.exports = __webpack_public_path__ + "static/media/desert-large.0c0d1f69.png";